import { render, staticRenderFns } from "./CompanyLogoCarousel.vue?vue&type=template&id=2103674a&scoped=true&"
import script from "./CompanyLogoCarousel.vue?vue&type=script&lang=js&"
export * from "./CompanyLogoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLogoCarousel.vue?vue&type=style&index=0&id=2103674a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103674a",
  null
  
)

export default component.exports